﻿import { createApp } from 'vue/dist/vue.esm-bundler';
const axios = require('axios');
import { tns } from 'tiny-slider/src/tiny-slider.js';
import eventBlock from './Vue/eventBlock.vue';

document.addEventListener('DOMContentLoaded', () => {
    const $eventsWidgets = document.querySelectorAll('.widget-events');

    if ($eventsWidgets.length) {
        var appArray = [];
    }

    $eventsWidgets.forEach(function ($eventsWidget, index) {
        appArray[index] = createApp({
            components: {
                eventBlock
            },
            data() {
                return {
                    dataApi: '',
                    dataCurrentPageId: '',
                    dataOverruleIds: [],
                    dataRecommendedIds: [],
                    dataType: '',
                    dataGenresCourses: [],
                    dataGenresShows: [],
                    dataLimit: 10, // Default limit in BE
                    dataSortKey: '',
                    dataSortDirection: '',
                    loading: true,
                    data: [],
                }
            },
            computed: {
                orderItems() {
                    if (!this.dataSortKey && !this.dataSortDirection) return [];
                    return [
                        {
                            Key: this.dataSortKey,
                            Direction: this.dataSortDirection,
                        }
                    ]
                },
                generalFilterItems() {
                    let filterItems = [{
                        Key: 'availability.orderStatus',
                        Values: [2, 3],
                        Operator: 'NotEq'
                    }];
                    if (this.dataCurrentPageId) {
                        filterItems.push({
                            Key: 'cmsId.keyword',
                            Values: [this.dataCurrentPageId],
                            Operator: 'NotEq'
                        });
                    }
                    if (this.dataType) {
                        filterItems.push({
                            Key: 'agendaType.keyword',
                            Values: [this.dataType],
                            Operator: 'Eq'
                        });
                    }

                    return filterItems;
                },

            },
            methods: {
                distinctBy(array, keySelector) {
                    const seen = new Map();
                    for (const item of array) {
                        const key = keySelector(item);
                        if (!seen.has(key)) {
                            seen.set(key, item);
                        }
                    }
                    return [...seen.values()];
                },
                async updateData() {
                    //prioriteiten zijn als volgt: eerst manual overrules, dan recommended, dan genre. als niks dan alles

                    var overruledShows = [];
                    var shows = [];

                    // get manual overrules
                    if (this.dataOverruleIds.length) {
                        var overruleShows = await this.getDataOnIds(this.dataOverruleIds);
                        overruledShows.push(...overruleShows);
                        overruledShows = overruledShows.sort((a, b) => this.dataOverruleIds.indexOf(a.cmsId) - this.dataOverruleIds.indexOf(b.cmsId));
                        this.data = this.data.concat(overruledShows);
                    } 
                    // get recommended
                    if (shows.length < this.dataLimit && this.dataRecommendedIds.length) {
                        var recommendedShows = await this.getDataOnIds(this.dataRecommendedIds, true);
                        shows.push(...recommendedShows);
                    }

                    if (shows.length < this.dataLimit && this.dataGenresShows.length) {
                        // get show genres
                        var showsforGenres = await this.getDataForGenres(this.dataGenresShows);
                        if (showsforGenres.length) shows.push(...showsforGenres);
                    }

                    if (shows.length < this.dataLimit && this.dataGenresCourses.length) {
                        // get course genres (disciplines)
                        var showsforGenres = await this.getDataForCourseTypes(this.dataGenresCourses);
                        if (showsforGenres.length) shows.push(...showsforGenres);
                    }

                    if (shows.length < this.dataLimit) {
                        //get all shows, if there is a page type only of that type
                        var allShows = await this.getAllData();
                        if (allShows.length) shows.push(...allShows);
                    }
                    shows.sort((a, b) => new Date(a.firstChildStartDate) - new Date(b.firstChildStartDate));
                    
                    this.data = this.data.concat(shows);
                    this.data = this.removeDuplicatesById(this.data);
                    this.data = this.data.slice(0, this.dataLimit);
                },
                async getDataOnIds(ids, onlyOneShowFromProduction = false) {
                    var queryModel = this.createQueryModel(ids, [], []);
                    var data = await this.fetchData(queryModel);

                    if (onlyOneShowFromProduction && data.length)
                    {
                        data = this.distinctBy(data, item => item.providerId)
                    }

                    return data;

                },
                async getDataForGenres(genres) {
                    var queryModel = this.createQueryModel([], genres, []);
                    var data = await this.fetchData(queryModel);

                    return data;
                },
                async getDataForCourseTypes(courseTypes) {
                    var queryModel = this.createQueryModel([], [], courseTypes);
                    var data = await this.fetchData(queryModel);

                    return data;
                },
                async getAllData() {
                    var query = {
                        Limit: this.dataLimit,
                        OrderItems: this.orderItems,
                        FilterItems: this.generalFilterItems
                    }
                    var data = await this.fetchData(query);
                    return data;
                },
                createQueryModel(ids, genres, courseTypes) {
                    var filters = [];
                    if (ids.length) {
                        var idsFilterItem = {
                            Key: 'cmsId.keyword',
                            Values: ids,
                            Operator: 'In'
                        };
                        filters.push(idsFilterItem);
                        return {
                            Limit: this.dataLimit,
                            OrderItems: this.orderItems,
                            FilterItems: filters
                        }
                    }
                    filters.push(...this.generalFilterItems);
                    if (genres.length) {
                        var genresFilterItem = {
                            Key: 'genres.name.keyword',
                            Values: genres,
                            Operator: 'In'
                        };
                        filters.push(genresFilterItem);
                        return {
                            Limit: this.dataLimit,
                            OrderItems: this.orderItems,
                            FilterItems: filters
                        }
                    }
                    if (courseTypes.length) {
                        var courseTypesFilterItem = {
                            Key: 'courseTypes.name.keyword',
                            Values: courseTypes,
                            Operator: 'In'
                        };
                        filters.push(courseTypesFilterItem);
                        return {
                            Limit: this.dataLimit,
                            OrderItems: this.orderItems,
                            FilterItems: filters
                        }
                    }
                },
                async fetchData(querymodel) {
                    var result = [];
                    try {
                        const response = await axios.post(this.dataApi, querymodel);
                        if (!response || response.status != 200) return;

                        if (response.data.items && response.data.items.length) {
                            response.data.items.forEach(item => {
                                result.push(item);
                            });
                        }
                        return result;
                    }
                    catch (error) {
                        console.log("error during fetch:", error)
                    }
                },
                removeDuplicatesById(array) {
                    return array.reduce((accumulator, current) => {
                        if (!accumulator.find((item) => item.id === current.id)) {
                            accumulator.push(current);
                        }
                        return accumulator;
                    }, []);
                },
                
            },
            updated() {
                if (this.data && this.data.length && !this.loading) {
                    if (this.$el.querySelector('.slider-list-container--vue')) {
                        tns({
                            container: this.$el.querySelector('.slider-list'),
                            speed: 500,
                            items: 1,
                            slideBy: 1,
                            center: true,
                            gutter: 20,
                            prevButton: this.$el.querySelector('.tns-button-prev'),
                            nextButton: this.$el.querySelector('.tns-button-next'),
                            mouseDrag: true,
                            nav: false,
                            responsive: {
                                768: {
                                    items: 2,
                                    center: false,
                                },
                                1024: {
                                    items: 3,
                                    center: false
                                }
                            }
                        });
                    }
                }
            },
            async mounted() {
                //set general data
                if (this.$el.dataset.api) this.dataApi = this.$el.dataset.api;
                if (this.$el.dataset.limit) this.dataLimit = parseInt(this.$el.dataset.limit);
                if (this.$el.dataset.currentpageid) this.dataCurrentPageId = this.$el.dataset.currentpageid;
                if (this.$el.dataset.sortkey) this.dataSortKey = this.$el.dataset.sortkey;
                if (this.$el.dataset.sortdirection) this.dataSortDirection = this.$el.dataset.sortdirection;
                if (this.$el.dataset.type) this.dataType = this.$el.dataset.type;
                if (this.$el.dataset.recommendedids) this.dataRecommendedIds = this.$el.dataset.recommendedids.split(',')       
                if (this.$el.dataset.overruleids) this.dataOverruleIds = this.$el.dataset.overruleids.split(',');
                if (this.$el.dataset.genresshows) this.dataGenresShows = this.$el.dataset.genresshows.split(',');               
                if (this.$el.dataset.genrescourses) this.dataGenresCourses = this.$el.dataset.genrescourses.split(',');

                await this.updateData();

                this.loading = false;
            }
        });
        appArray[index].mount($eventsWidget);
    });
});
